import { render, staticRenderFns } from "./TheCartComeBack.vue?vue&type=template&id=2123e3c2&"
import script from "./TheCartComeBack.vue?vue&type=script&lang=js&"
export * from "./TheCartComeBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports